import { MruFileItem } from '../../shared/mru/mru-file-item.model';

type DocumentMap = { [pinState: string]: Array<MruFileItem> };

export class DocumentCollection {

    private readonly documents: DocumentMap;

    private static readonly AllCategoryKey = 'all';
    private static readonly PinnedStateKey = 'pinned';
    private static readonly UnpinnedStateKey = 'unpinned';

    constructor(items: Array<MruFileItem>) {
        const pinnedItems: Array<MruFileItem> = [];
        const unpinnedItems: Array<MruFileItem> = [];
        for (let i = 0; i < items.length; i++) {
            const mruItem = items[i];
            if (mruItem.isPinned) {
                pinnedItems.push(mruItem);
            } else {
                unpinnedItems.push(mruItem);
            }
        }

        this.documents = { [DocumentCollection.PinnedStateKey]: pinnedItems, [DocumentCollection.UnpinnedStateKey]: unpinnedItems, [DocumentCollection.AllCategoryKey]: items };
    }

    public getAllPinnedDocuments(): Array<MruFileItem> {
        return this.documents[DocumentCollection.PinnedStateKey] || [];
    }

    public getAllUnpinnedDocuments(): Array<MruFileItem> {
        return this.documents[DocumentCollection.UnpinnedStateKey] || [];
    }

    public getAllDocuments(): Array<MruFileItem> {
        return this.documents[DocumentCollection.AllCategoryKey] || [];
    }

    public removeItem(item: MruFileItem) {
        const filteredItemsList: Array<MruFileItem> = item.isPinned ? this.getAllPinnedDocuments() : this.getAllUnpinnedDocuments();
        this.deleteItemFromList(filteredItemsList, item);
        this.deleteItemFromList(this.getAllDocuments(), item);
    }

    public addItem(item: MruFileItem) {
        const filteredItemsList: Array<MruFileItem> = item.isPinned ? this.getAllPinnedDocuments() : this.getAllUnpinnedDocuments();
        this.addItemToList(filteredItemsList, item);
        this.addItemToList(this.getAllDocuments(), item);
    }

    private deleteItemFromList(items: Array<MruFileItem>, item: MruFileItem) {
        if (!items) {
            return;
        }

        for (let i = 0; i < items.length; i++) {
            if (items[i].id === item.id) {
                items.splice(i, 1);
                return;
            }
        }
    }

    private addItemToList(items: Array<MruFileItem>, item: MruFileItem) {
        if (!items) {
            return;
        }

        for (let i = 0; i < items.length; i++) {
            if (items[i].lastViewedTime <= item.lastViewedTime) {
                items.splice(i, 0, item);
                return;
            }
        }

        items.push(item);
    }
}
